import { Button, Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { addProfessionalProfile } from "redux/actions";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

function AddProfessionalProfile({ closeModel }) {
  const dispatch = useDispatch();
  const [form] = useForm();

  const onFinish = (values) => {
    dispatch(addProfessionalProfile(values));
    closeModel();
  };

  return (
    <Form
      form={form}
      className="edit-customer-form"
      name="validate_other"
      {...formItemLayout}
      onFinish={onFinish}
      layout="vertical"
      initialValues={{
        professionalProfileName: "",
        professionalProfileName_es: "",
      }}
    >
      <Form.Item
        label="Name"
        name="professionalProfileName"
        rules={[
          { required: true, whitespace: true, message: "Name is required" },
        ]}
      >
        <Input
          name="professionalProfileName"
          placeholder="Professional Profile Name"
        />
      </Form.Item>
      <Form.Item
        label="Nombre"
        name="professionalProfileName_es"
        rules={[
          {
            required: true,
            whitespace: true,
            message: "El nombre es necesario",
          },
        ]}
      >
        <Input
          name="professionalProfileName"
          placeholder="Nombre del perfil profesional"
        />
      </Form.Item>

      <Form.Item
        wrapperCol={{
          span: 12,
          offset: 9,
        }}
      >
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default AddProfessionalProfile;

AddProfessionalProfile.propTypes = {
  closeModel: PropTypes.func,
};
